<template>
    <vs-popup :active.sync="isActive"  title="Gün Ortası">
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
<h3>Lütfen Kasadaki Nakit Parayı Sayarak Gün Ortasını Yapınız</h3>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" class="mt-4">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input @focus="$event.target.select()" id="Nakit" name="Nakit" v-validate="'required'" v-model="safeCash" label-placeholder="Kasa Anlık Nakit: " @input="handleInput">
                
            </vs-input>

          </vs-col>
        </vs-row>
        
          <vs-row vs-type="flex" vs-w="12" class="mt-4">
            
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
              <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white ml-2">
                Onayla
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-row>
        
      <div fullscreen style="z-index: 9999999;" class="popup-overlay" v-if="showPopupFlag">
        <div fullscreen class="popup">
          <h3>Ara raporu kaydetmek istediğinize eminmisiniz?</h3>
          <button class="btn btn-primary" @click="forcelose">Kaydet</button>
          <button class="btn btn-secondary" @click="closePopup">İptal</button>
        </div>
      </div>
    </vs-popup>
  </template>
  
  <script>
  import {
    createDayOpen,
    createDayInterim
  } from "@/api/DayOpen.js";
  import companyInfo from "../../../model/constants/companyInfo";
  export default {
    data() {
      return {
        isActive: false, // Pop-up'ı başlangıçta açık tutmak için
        logo: companyInfo.logo,
        showPopupFlag: false,
        safeCash: 0,
        xCash: 0,
        multinet: 0,
        sodexo:0,
        ticket:0,
        setCard:0,
        migros: 0,
        metropol: 0,
        tokenflex: 0,
        getir: 0,
        yemekSepeti: 0,
        trendyol: 0
      };
    },
    computed:{
      activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    }
    },
    watch:{
      isActive(val) {
          this.safeCash = 0;
        }
    },
    methods: {
        handleInput() {
      // Girilen değeri kontrol et
      if (this.safeCash !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.safeCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.safeCash = this.safeCash.slice(0, -1); // En son karakteri siler
        }
      }
    },
    handleInputForX() {
      // Girilen değeri kontrol et
      if (this.xCash !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.xCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.xCash = this.xCash.slice(0, -1); // En son karakteri siler
        }
      }
    },
        showPopup: async function () {
          let checker = await this.$validator.validateAll(); 
         if (!checker) {
          return;
         }
        this.showPopupFlag = true
      },
        closePopup() {
        this.showPopupFlag = false;
      },
        forcelose: async function () {
            createDayInterim({safeCash :this.safeCash, xReportForCard : this.xCash,multinetReport: this.multinet,
              sodexoReport: this.sodexo, ticketReport: this.ticket, setcardReport:this.setCard, metropolReport: this.metropol,
              tokenflexReport:this.tokenflex, getirReport: this.getir, yemekSepetiReport: this.yemekSepeti, 
              trendyolReport: this.trendyol, migrosReport: this.migros,userId:this.activePersonel.id, userName:this.activePersonel.name }).then(res =>{
                if (res && res.status == 200) {
                    this.$vs.notify({
            color: 'success',
            title: 'Gün ortası başarılı',
            text: 'Gün ortası başarılı !'
          });
          this.$emit("emitDisable", true);
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ödeme Raporu Yüklenemedi !'
            });
          }
            }).catch(error => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
            this.showPopupFlag = false;
            this.isActive = false;
        },
      preventCloseOnClick() {
        // İhtiyaca göre özel mantık ekleyebilirsiniz
      },
      handlePopupUpdate(newValue) {
      // Pop-up durumu güncellendiğinde tetiklenir
      if (!newValue) {
        // Pop-up kapatıldığında yapılacak işlemler
        this.isActive = true; // Pop-up'ı tekrar açmak için
      }
    },
    },
  };
  </script>
  <style>
  
  .logo{
    background-color: white;
       border-radius: 10px;
    margin-bottom: 1rem;
  }
  #switchScreen{
    z-index: 999999;
  }
  #switchScreen .vs-popup .vs-popup--header {
    display: none !important;
  }
  
  #switchScreen .vs-popup .vs-popup--content {
    padding: 0 !important;
    /*height: 47vh;*/
  }
  
  #switchScreen .vs-popup {
    background: transparent !important;
    box-shadow: none !important;
  }
  
  #switchScreen input {
    font-size: 2rem !important;
    background: #f2f2f2 0% 0% no-repeat padding-box !important;
    text-align: center !important;
    padding: 0.5rem;
  }
  </style>
  